import classes from './overlayWithSpinner.module.scss';

const OverlayWithSpinner = () => {
    return <div data-testid={'overlay-with-spinner'} className={classes.overlayWithSpinner} />;
};

export default OverlayWithSpinner;
